import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider
} from "@mui/material";

import {
  Facebook,
  Instagram,
  YouTube,
  Twitter,
  LocationOn,
  Email,
  Phone
} from "@mui/icons-material";

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: "#ffffff", pt: 8,mr:{md:0,xs:8} }}>
      <Grid
        container
        spacing={6}
        sx={{ maxWidth: "1200px", mx: "auto", px: 2 }}
      >
        {/* Brand Info */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
          >
            🏔️ Go
            <Box component="span" sx={{ color: "#2E7D32", ml: 0.5 }}>
              Himachal
            </Box>
          </Typography>

          <Typography
            variant="body2"
            sx={{ mt: 2, color: "#666", lineHeight: 1.7 }}
          >
            Go Himachal is a trusted travel partner offering premium taxi
            services, curated tour packages, trekking adventures, motorcycle
            tours, and unforgettable Himachal travel experiences.
          </Typography>

          <Box sx={{ display: "flex", gap: 1.5, mt: 3 }}>
            {[Facebook, Instagram, Twitter, YouTube].map((Icon, i) => (
              <IconButton
                key={i}
                sx={{
                  backgroundColor: "#F5F5F5",
                  "&:hover": { backgroundColor: "#2E7D32", color: "#fff" }
                }}
              >
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Box>
        </Grid>

        {/* Services */}
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
            Services
          </Typography>
          {[
            "Tour Packages",
            "Trekking Tours",
            "Motorcycle Tours",
            "Car Rentals",
            "Ticket Booking"
          ].map((item) => (
            <Typography
              key={item}
              variant="body2"
              sx={{ color: "#666", mb: 1, cursor: "pointer" }}
            >
              {item}
            </Typography>
          ))}
        </Grid>

        {/* Contact */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
            Reach Us
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#666", display: "flex", mb: 1.5 }}
          >
            <LocationOn sx={{ mr: 1, color: "#2E7D32" }} />
            SCO 47, Sector 71, Mohali, Punjab
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#666", display: "flex", mb: 1.5 }}
          >
            <Email sx={{ mr: 1, color: "#2E7D32" }} />
            info@gohimachal.in
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#666", display: "flex" }}
          >
            <Phone sx={{ mr: 1, color: "#2E7D32" }} />
            +91 62302 06562
          </Typography>
        </Grid>

        {/* Newsletter */}
        <Grid item xs={12} md={3}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
            Subscribe For Newsletter
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              size="small"
              fullWidth
              placeholder="Enter your email"
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#000",
                width: "300px",
                "&:hover": { backgroundColor: "#2E7D32" }
              }}
            >
              Subscribe
            </Button>
          </Box>

          <Typography
            variant="caption"
            sx={{ color: "#999", mt: 1, display: "block" }}
          >
            No spam. Only travel inspiration ✨
          </Typography>
        </Grid>
      </Grid>

      {/* Divider */}
      <Divider sx={{ my: 5 }} />

      {/* Bottom Bar */}
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: 2,
          pb: 3,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          ml: { md: 0, xs: 6 }
        }}
      >
        <Typography variant="caption" sx={{ color: "#666" }}>
          © 2017–2025 Go Himachal India LLP. All rights reserved.
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>
          {["Privacy Policy", "Terms", "Accessibility"].map((item) => (
            <Typography
              key={item}
              variant="caption"
              sx={{ color: "#666", cursor: "pointer" }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
